module.exports = __webpack_public_path__ + "static/media/search.d9454a34.png";